import { render, staticRenderFns } from "./UnitPrice.vue?vue&type=template&id=2d0ae478&scoped=true"
import script from "./UnitPrice.vue?vue&type=script&lang=js"
export * from "./UnitPrice.vue?vue&type=script&lang=js"
import style0 from "./UnitPrice.vue?vue&type=style&index=0&id=2d0ae478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ae478",
  null
  
)

export default component.exports